export default __webpack_public_path__ + "7418cf0903cdd2f1dccdd10fd5e912be.jpg";